// extracted by mini-css-extract-plugin
module.exports = {"userImg":"uploadfile_userImg__31gxS","userImgContainer":"uploadfile_userImgContainer__3Xd0h","placeholder":"uploadfile_placeholder__2KLxT"};